import React from 'react';

const PrivacyPolicy = () => {
  const styles:any = {
    container: {
      maxWidth: '800px',
      margin: '0 auto',
      padding: '20px',
      backgroundColor: '#ffffff',
      color: '#000000',
      fontFamily: "'Arial', sans-serif",
      lineHeight: 1.6
    },
    header: {
      textAlign: 'center',
      marginBottom: '30px',
      borderBottom: '2px solid #000000',
      paddingBottom: '20px'
    },
    title: {
      fontSize: '2rem',
      fontWeight: 'bold',
      margin: 0,
      color: '#000000'
    },
    divider: {
      height: '1px',
      backgroundColor: '#000000',
      margin: '30px 0',
      width: '100%'
    },
    content: {
      marginBottom: '40px'
    },
    section: {
      marginBottom: '30px'
    },
    sectionTitle: {
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginBottom: '15px',
      color: '#000000',
      borderLeft: '4px solid #000000',
      paddingLeft: '10px'
    },
    text: {
      marginBottom: '15px',
      color: '#333333'
    },
    emphasizedText: {
      marginBottom: '15px',
      fontWeight: 'bold',
      color: '#000000'
    },
    subsection: {
      margin: '20px 0'
    },
    subsectionTitle: {
      fontSize: '1.2rem',
      fontWeight: 'bold',
      marginBottom: '10px',
      color: '#000000'
    },
    listContainer: {
      listStyleType: 'none',
      paddingLeft: '20px',
      marginBottom: '20px'
    },
    listItem: {
      marginBottom: '8px',
      paddingLeft: '20px',
      position: 'relative',
      color: '#333333'
    },
    listBullet: {
      position: 'absolute',
      left: 0,
      color: '#000000',
      fontWeight: 'bold'
    },
    contactInfo: {
      listStyleType: 'none',
      paddingLeft: 0,
      marginTop: '20px'
    },
    contactItem: {
      display: 'flex',
      alignItems: 'center',
      marginBottom: '15px',
      padding: '10px',
      backgroundColor: '#f5f5f5',
      borderRadius: '4px'
    },
    contactIcon: {
      marginRight: '15px',
      fontSize: '1.2rem'
    },
    contactText: {
      color: '#000000',
      fontWeight: 500
    },
    footer: {
      textAlign: 'center',
      paddingTop: '20px',
      borderTop: '1px solid #000000',
      marginTop: '30px'
    },
    footerText: {
      color: '#666666',
      fontSize: '0.9rem'
    }
  };

  // Estilos responsivos
  const mediaQuery = window.matchMedia('(max-width: 768px)');
  if (mediaQuery.matches) {
    styles.title.fontSize = '1.7rem';
    styles.sectionTitle.fontSize = '1.3rem';
  }

  return (
    <div style={styles.container}>
      <header style={styles.header}>
        <h1 style={styles.title}>Política de Privacidade – ClikMob</h1>
        <div style={styles.divider}></div>
      </header>
      
      <main style={styles.content}>
        <section style={styles.section}>
          <p style={styles.text}>
            A ClikMob respeita a sua privacidade e está comprometida em proteger os dados pessoais de seus usuários. 
            Esta Política de Privacidade descreve como coletamos, usamos, armazenamos e protegemos suas informações 
            ao utilizar nosso aplicativo de mobilidade.
          </p>
          <p style={styles.emphasizedText}>
            Ao utilizar o aplicativo ClikMob, você concorda com as práticas descritas nesta Política.
          </p>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>1. Informações que coletamos</h2>
          <p style={styles.text}>
            Podemos coletar as seguintes informações:
          </p>
          
          <div style={styles.subsection}>
            <h3 style={styles.subsectionTitle}>1.1 Informações fornecidas pelo usuário</h3>
            <ul style={styles.listContainer}>
              <li style={styles.listItem}><span style={styles.listBullet}>•</span> Nome completo</li>
              <li style={styles.listItem}><span style={styles.listBullet}>•</span> Número de telefone</li>
              <li style={styles.listItem}><span style={styles.listBullet}>•</span> Endereço de e-mail</li>
              <li style={styles.listItem}><span style={styles.listBullet}>•</span> Dados de cadastro e autenticação</li>
            </ul>
          </div>
          
          <div style={styles.subsection}>
            <h3 style={styles.subsectionTitle}>1.2 Informações coletadas automaticamente</h3>
            <ul style={styles.listContainer}>
              <li style={styles.listItem}><span style={styles.listBullet}>•</span> Localização em tempo real (para funcionamento do serviço de mobilidade)</li>
              <li style={styles.listItem}><span style={styles.listBullet}>•</span> Endereço IP</li>
              <li style={styles.listItem}><span style={styles.listBullet}>•</span> Informações do dispositivo (modelo, sistema operacional, versão do app)</li>
              <li style={styles.listItem}><span style={styles.listBullet}>•</span> Dados de uso do aplicativo</li>
            </ul>
          </div>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>2. Finalidade do uso das informações</h2>
          <p style={styles.text}>
            Utilizamos os dados coletados para:
          </p>
          <ul style={styles.listContainer}>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Fornecer e operar os serviços de mobilidade</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Conectar usuários a motoristas/parceiros</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Melhorar a experiência do usuário</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Garantir a segurança do aplicativo</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Cumprir obrigações legais e regulatórias</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Enviar comunicações relacionadas ao serviço</li>
          </ul>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>3. Compartilhamento de dados</h2>
          <p style={styles.text}>
            A ClikMob não vende dados pessoais. Os dados poderão ser compartilhados apenas:
          </p>
          <ul style={styles.listContainer}>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Com motoristas/parceiros para execução das viagens</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Com prestadores de serviço essenciais ao funcionamento do app</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Para cumprimento de obrigações legais ou ordens judiciais</li>
          </ul>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>4. Uso da localização</h2>
          <p style={styles.text}>
            O acesso à localização é essencial para:
          </p>
          <ul style={styles.listContainer}>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Solicitação e execução de viagens</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Cálculo de rotas e estimativas</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Segurança do usuário</li>
          </ul>
          <p style={styles.text}>
            A localização pode ser coletada mesmo quando o aplicativo estiver em segundo plano, 
            desde que autorizado pelo usuário.
          </p>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>5. Armazenamento e segurança dos dados</h2>
          <p style={styles.text}>
            Adotamos medidas técnicas e organizacionais para proteger os dados contra:
          </p>
          <ul style={styles.listContainer}>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Acesso não autorizado</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Perda, uso indevido ou divulgação indevida</li>
          </ul>
          <p style={styles.text}>
            Os dados são armazenados apenas pelo tempo necessário para cumprir as finalidades 
            descritas nesta Política.
          </p>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>6. Direitos do titular dos dados</h2>
          <p style={styles.text}>
            Nos termos da Lei Geral de Proteção de Dados (Lei nº 13.709/2018 – LGPD), você tem direito a:
          </p>
          <ul style={styles.listContainer}>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Acessar seus dados</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Corrigir dados incorretos</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Solicitar a exclusão dos dados</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Revogar o consentimento</li>
          </ul>
          <p style={styles.text}>
            As solicitações podem ser feitas pelo e-mail informado abaixo.
          </p>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>7. Retenção de dados</h2>
          <p style={styles.text}>
            Os dados pessoais serão mantidos:
          </p>
          <ul style={styles.listContainer}>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Enquanto a conta estiver ativa</li>
            <li style={styles.listItem}><span style={styles.listBullet}>•</span> Pelo período exigido por lei, quando aplicável</li>
          </ul>
          <p style={styles.text}>
            Após esse prazo, os dados serão eliminados ou anonimizados.
          </p>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>8. Alterações nesta Política</h2>
          <p style={styles.text}>
            Esta Política de Privacidade pode ser atualizada a qualquer momento.
          </p>
          <p style={styles.text}>
            Recomendamos que o usuário revise periodicamente este documento.
          </p>
          <div style={styles.divider}></div>
        </section>
        
        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>9. Contato</h2>
          <p style={styles.text}>
            Em caso de dúvidas, solicitações ou reclamações sobre esta Política, entre em contato:
          </p>
          <ul style={styles.contactInfo}>
            <li style={styles.contactItem}>
              <span style={styles.contactIcon}>📧</span> 
              <span style={styles.contactText}>E-mail: contato@clikmob.com</span>
            </li>
            <li style={styles.contactItem}>
              <span style={styles.contactIcon}>🏢</span> 
              <span style={styles.contactText}>Responsável: ClikMob – Aplicativo de Mobilidade</span>
            </li>
          </ul>
        </section>
      </main>
      
      <footer style={styles.footer}>
        <p style={styles.footerText}>ClikMob © {new Date().getFullYear()} - Todos os direitos reservados</p>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;